angular.module('checkout').service('termsDialog',
    [
        '$sce',
        'rcmDialogService',
        'translateFilter',
        'rcmApiLibService',
        function ($sce, rcmDialogService, translateFilter, rcmApiLibService) {
            let self = this;

            /**
             * showTerms
             *
             * @param {String} termsKey
             * @param {Object} order
             * @param {Object} newProfile
             * @param {Function} ajaxErrorHandler
             */
            self.showTerms = function (termsKey, order, newProfile, ajaxErrorHandler) {

                let alias = order.attributes.termsConditionsRules.requiredTermsConditionsAliases[termsKey];
                if (!alias) {
                    return;
                }

                rcmApiLibService.get(
                    {
                        url: '/api/terms-conditions/{alias}',
                        urlParams: {alias: alias},
                        loading: function (loading) {
                            let loadingInt = Number(!loading);
                            rcmLoading.setLoading(
                                'termConditions.loading',
                                loadingInt
                            );
                        },
                        success: function (response) {
                            onTermsConditionsSuccess(response, newProfile);
                        },
                        error: function (response) {
                            ajaxErrorHandler(response.messages);
                        },
                    }
                );
            };

            /**
             * onTermsConditionsSuccess
             */
            let onTermsConditionsSuccess = function (response, newProfile) {
                self.termsConditions = response.data;
                self.termsConditions.content = $sce.trustAsHtml(
                    self.termsConditions.content
                );

                let dialog = rcmDialogService.buildDialog(
                    null,
                    translateFilter('Terms and Agreements'),
                    //@TODO import this template file rather than lazy loading it to removed dependency on "app_components" path
                    '/app_components/cart-ui/src/page/terms/terms.html',
                    'rcmStandardDialog',  // Dialog strategy, will use the default strategy if null
                    {
                        'accept': {
                            type: 'button',
                            label: translateFilter('I accept the') + ' ' + translateFilter(
                                'Terms and Agreements'
                            ),
                            css: 'btn btn-primary',
                            method: function (dialog) {
                                if (newProfile) {
                                    newProfile.acceptedTerms = true;
                                }
                                dialog.close();
                            },
                        },
                        'close': {
                            type: 'button',
                            label: translateFilter('Cancel'),
                            css: 'btn btn-default',
                            method: function (dialog) {
                                if (newProfile) {
                                    newProfile.acceptedTerms = false;
                                }
                                dialog.close();
                            },
                        },
                    },
                    self
                );

                dialog.open();
            };
        },
    ]
);
